module.exports = __webpack_public_path__ + "img/refarral-new-3.0b32929a.png";